import * as joint from '@clientio/rappid'

export default class BurgerMenu extends joint.elementTools.Button {
  constructor(private runnable: (cellView: joint.dia.CellView) => void) {
    super({
      className: 'BurgerMenu',
      markup: [
        {
          tagName: 'circle',
          selector: 'button',
          attributes: {
            r: 14,
            fill: 'rgba(1, 1, 1, .07)',
            cursor: 'pointer',
          },
        },
        {
          tagName: 'path',
          selector: 'icon',
          attributes: {
            d: 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z',
            fill: 'black',
            transform: 'scale(0.8 0.8) translate(-12 -12)',
          },
        },
      ],
      x: '95%',
      y: 0,
      offset: {
        x: 0,
        y: 20,
      },
      rotate: true,
      action: function (evt: any, cellView: joint.dia.CellView) {
        if (runnable) {
          runnable(cellView)
          //define action which could be executed when clicking ont he Burger Button
        }
      },
    })
  }
}
